import React from 'react';
import Preloader from 'components/Preloader';
import { useClientLayout } from 'pages/ClientOverview/hooks/useClientLayout';
import CaseDetailsManager from 'datasource/CaseManagement/CaseDetailsManager/CaseDetailsManager';
import CaseDetails from 'widgets/CaseManagement/CaseDetails';

const CaseDetailsPage = ({ submittedCase = false }) => {
    useClientLayout();

    return (
        <Preloader isLoading={false}>
            <CaseDetailsManager submittedCase={submittedCase}>
                <div className="container">
                    <div className="fi-verticals">
                        <CaseDetails submittedCase={submittedCase} />
                    </div>
                </div>
            </CaseDetailsManager>
        </Preloader>
    );
};

export default React.memo(CaseDetailsPage);
